<template>
    <div v-if="buttonInitiated">
        <div v-if="(!isAllowRedeem && isErrCondition) || showExplorePrestigeCase" class="border-top"></div>
        <div class="box-warning" v-if="(!isAllowRedeem && isErrCondition) || showExplorePrestigeCase">
            <img src="@/assets/icon/ic-error-serial.svg" alt="">
            <div>{{ showExplorePrestigeCase ? lblRedeemBTN.notAvailableTier : buttonLbl }}</div>
        </div>
        <!-- <div v-if="!isAllowRedeem && isErrCondition" class="border-top"></div>
        <div class="box-warning" v-if="!isAllowRedeem && isErrCondition">
            <img src="@/assets/icon/ic-error-serial.svg" alt="">
            <div>{{ buttonLbl }}</div>
        </div> -->
        <PrimaryButton
            btnId="redeem_btn"
            :btnMsg="isErrCondition ? lblRedeemBTN.default : buttonLbl"
            :isBtnDisable="detailController.isLoading || !isAllowRedeem"
            :isLoading="detailController.isLoading"
            @clickButton="clickRedeem()" />
    </div>
</template>
<script>
import Vue from "vue";
// helper
import Util from "@/helper/Utility.js";
// component
import PrimaryButton from "@/components/Button/PrimaryButton.vue";
/**
 * Property
 * @property {boolean} isLogin (required) Is user logged in.
 * @property {number} point (required) User available point.
 * @property {number} selectedPoint (required) Point amount for redeem campaign.
 * @property {number} selectedQuantity (required) Campaign's quantity.
 * @property {object} lblRedeemBTN (required) Text for component.
 * @property {object} campaign (required) Campaign data.
 * @property {object} redeemBTN (required) Redeem information (redeemable, isDisable etc.).
 *
 * Event
 * @event clickRedeem Callback to parent component when click redeem button.
 * Method
 * @method initialRedeemButton Setup redeem button data (text, redeemable, disable css class, etc.).
 *
 * Utilities
 * @method cleanRedeemButtonLabel Replace \n with <br/>.
 * @method getRedeemButtonClass Get redeem current css class.
 */

export default {
    name: "RedeemButton",
    components: {
        PrimaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        },
        showExplorePrestigeCase: function () {
            return this.theme == 'mass' && this.isErrCredit && this.point > 0;
        },
        exploreAiaPrestigeUrl: function () {
            var config = this.$store.state.aiaConfig;
            return (config && config.exploreAiaPrestige && config.exploreAiaPrestige.url)
                ? config.exploreAiaPrestige.url
                : null;
        },
    },
    props: {
        isLogin: Boolean,
        userPoint: Number,
        isCheckQuotaAvailable: Boolean,
        isQuotaAvailable: Boolean,

        lblRedeemBTN: Object,
        modalController: Object,
        detailController: Object
    },
    data: function() {
        return {
            type: null,
            point: 0,
            pointType: '',
            quantity: 0,
            campaign: {},

            buttonClass: 'redeem-disable',
            buttonLbl: '',
            buttonInitiated: false,
            isAllowRedeem: false,
            isUseDefault: false,
            isErrCredit: false,
            isErrCondition: false
        };
    },
    created: function () {
        this.type = this.detailController.type;
        // this.point = this.detailController.point;
        this.pointType = this.detailController.pointType;
        this.quantity = this.detailController.quantity;
        this.campaign = this.detailController.campaign;
    
        var isCredit = this.detailController.campaign && 
                this.detailController.campaign.pointServices &&
                this.detailController.campaign.pointServices.credit !== null &&
                this.detailController.campaign.pointServices.credit !== undefined &&
                this.detailController.campaign.pointServices.credit.amountPerUnit !== undefined;
        if (isCredit) {
            this.point = this.detailController.campaign.pointServices.credit.amountPerUnit;
            this.isErrCredit = true;
        } else {
            this.point = this.detailController.campaign.pointPerUnit;
            this.isErrCredit = false;
        }
        
        this.buttonLbl = this.lblRedeemBTN.default;
        if (this.campaign.type == Vue.CampaignType.Draw)
            this.buttonLbl = this.lblRedeemBTN.draw;

        this.isAllowRedeem = this.campaign.isConditionPass;
        this.isButtonDisable = !this.campaign.isConditionPass;
    },
    mounted: function () {
        this.initialRedeemButton();
        this.buttonClass = this.getRedeemButtonClass();
        this.buttonLbl = this.cleanRedeemButtonLabel();

        this.$nextTick(() => {
            this.buttonInitiated = true;
        });
    },
    methods: {
        //Event
        clickRedeem: function () {
            if (this.showExplorePrestigeCase && this.exploreAiaPrestigeUrl) {
                const url = this.exploreAiaPrestigeUrl;
                const os = Util.getOsName();

                if (os === 'iOS') {
                    const xSafariUrl = url.replace(/^https:\/\//i, 'x-safari-https://');
                    window.location.href = xSafariUrl;
                    return;
                }

                if (os === 'Android') {
                    window.open(url, '_blank');
                    return;
                }

                window.open(url, '_blank');
                return;
                // this.detailController.cbOpenIframe.sendCallback(this.exploreAiaPrestigeUrl);
                // return;
            }
            if (this.isAllowRedeem) {
                if (this.isLogin) {
                    this.detailController.clickRedeem();
                } else {
                    window.location.assign('/error/401');
                }
            }
        },
        //Function
        initialRedeemButton: function () {
            //Check is campaign supported.
            if (this.type == Vue.CampaignType.Bid ||
                this.type == Vue.CampaignType.Event ||
                this.type == Vue.CampaignType.Media) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'redeem-notsupport';
                this.buttonLbl = this.lblRedeemBTN.notSupport;
                return;
            }

            //check published.
            if (this.campaign.statusID != 3) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'redeem-notpublish';
                this.buttonLbl = this.lblRedeemBTN.notPublish;
                this.isErrCondition = true;
                return;
            }

            //Check expire date.
            if (this.campaign.currentDate > this.campaign.expireDate) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'redeem-expired';
                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                return;
            }
            //Check sold out.
            if (this.quantity <= 0) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "redeem-soldout";
                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                return;
            }

            // Check disabled from API - 
            // UserStory 792282 - Handle UI on Campaign Detail for Case "Disabled" : true
            if (this.campaign.meta && this.campaign.meta.disabled) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.isErrCondition = true;                
                this.buttonClass = 'redeem-maxperson';     
                this.buttonLbl = this.lblRedeemBTN.maxPerPerson;
                return;
            }

            // check theme and isErrCredit and point
            if (this.theme == 'mass' && this.isErrCredit && this.point > 0) {
                console.log('this.theme', this.theme);
                this.isAllowRedeem = true;
                this.isButtonDisable = false;
                this.buttonClass = 'redeem-eligible';
                this.buttonLbl = this.lblRedeemBTN.explor;
                return;
            }
            // console.log('this.userPoint', this.userPoint);
            // console.log('this.point', this.point);
            //Do validate when logged in.
            if (this.isLogin) {
                // WI #878678 / BR-3 / AC-4:
                // Block redeem when the session has no Customer Level, and show the
                // error text inline (box-warning) instead of a popup.
                if (!this.detailController.hasCustomerLevel()) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    this.isErrCondition = true;
                    this.buttonClass = 'redeem-condition';
                    this.buttonLbl = this.lblRedeemBTN.noLevelBlock;
                    return;
                }
                //Check user enough point.
                if (this.point > this.userPoint) {
                    if (this.pointType && this.pointType != 'use') {
                        //Get point, do nothing.
                    } else {
                        if (this.isErrCredit) {
                            this.isAllowRedeem = false;
                            this.isButtonDisable = true;
                            this.buttonClass = 'redeem-notenoughpoint';
                            this.buttonLbl = this.lblRedeemBTN.notEnoughCredit;
                        } else {
                            this.isAllowRedeem = false;
                            this.isButtonDisable = true;
                            this.buttonClass = 'redeem-notenoughpoint';
                            this.buttonLbl = this.lblRedeemBTN.notEnoughPoint;
                        }
                        
                        return;
                    }
                }
                
                //#region custom
                //check quota
                //2021-04-07 remove "!this.detailController.isAmbassadorCat" from expression [UserStory#154978]
                if (this.isCheckQuotaAvailable
                    && !this.isQuotaAvailable) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    this.buttonClass = 'redeem-exceed-quota';
                    this.buttonLbl = this.lblRedeemBTN.exceedQuota;
                    return;
                }
                //#endregion custom
                //Handle common case for custom text.
                if (!this.campaign.isConditionPass) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    //Use api text message.
                    if (this.isUseDefault) {
                        this.buttonClass = 'redeem-condition';
                        this.buttonLbl = this.campaign.conditionAlert;
                    } else {
                        this.isErrCondition = true;
                        switch (this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.buttonLbl = this.lblnone;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.buttonClass = "redeem-soldout";
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.buttonClass = "redeem-maxperson";
                                this.buttonLbl = this.lblRedeemBTN.maxPerPerson;
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.buttonClass = "redeem-cooldown";
                                this.buttonLbl = this.lblRedeemBTN.redeemCoolDown;
                                break;
                            case 4:
                                //Never see this.
                                this.buttonLbl = this.lblRedeemBTN.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.buttonClass = "redeem-eligible";
                                this.buttonLbl = this.lblRedeemBTN.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.buttonClass = "redeem-expired";
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignNotAvailableBuy : this.lblRedeemBTN.campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.buttonClass = "redeem-condition";
                                this.buttonLbl = this.campaign.conditionAlert;
                                break;
                        }
                    }
                } else {
                    this.buttonClass = 'redeem-allow';

                    if (this.campaign.customCaption) {
                        this.buttonLbl = this.campaign.customCaption;
                    }
                }
            } else {
                this.buttonClass = 'redeem-allow';

                if (this.campaign.customCaption) {
                    this.buttonLbl = this.campaign.customCaption;
                }
            }
        },
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.buttonLbl);
        },
        getRedeemButtonClass: function () {
            if (!this.isAllowRedeem)
                return this.buttonClass;

            return 'redeem-allow';
        }
    }

}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
.border-top {
    border-top: 1px solid $color-gray-D6D8DA;
    margin-top: 16px;
    padding-top: 16px;
}
.box-warning {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    color: $color-gray;
    font-size: 0.875rem;
    padding: 0px 0 16px;
    img {
        width: 24px;
        height: 24px;
        // padding-top: 4px;
    }
}
</style>
